var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { CandidateModel } from 'app/interfaces/candidate.model';
import { JobOffersService } from 'app/services';
var JobOffersSectionComponent = /** @class */ (function () {
    function JobOffersSectionComponent(jobOfferService) {
        this.jobOfferService = jobOfferService;
        this.jobOffersInput = null;
        this.candidateInput = null;
        this.specificJobOffer = null;
        this.isExternal = false;
        this.current = null;
        // @Output() changeProcessStatus: EventEmitter<any> = new EventEmitter<any>();
        this.jobOffers = null;
        this.candidate = null;
        this.models = {};
    }
    JobOffersSectionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.jobOffers = this.jobOffersInput;
        this.candidate = this.candidateInput;
        this.jobOffers.forEach(function (ele) {
            _this.models[ele.id] = {
                comments: ele.comment,
                applications_id: ele.id
            };
        });
        // console.log(this.models);
    };
    JobOffersSectionComponent.prototype.changeProcessStatus = function (j, ps) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (j.process_status === ps) {
                            ps = 'new';
                        }
                        return [4 /*yield*/, this.jobOfferService.changeApplicationProcessStatus(j.id, ps)];
                    case 1:
                        result = _a.sent();
                        j.process_status = result['process_status'];
                        return [2 /*return*/];
                }
            });
        });
    };
    JobOffersSectionComponent.prototype.openVideo = function (video) {
        var file = video;
        window.open(file, 'targetWindow', 'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=400, height=600, left=200, top=100');
    };
    return JobOffersSectionComponent;
}());
export { JobOffersSectionComponent };
